import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {Alert, Container, Typography,
    IconButton, InputAdornment, Grid, Link, Checkbox, 
    FormControlLabel, TextField, CssBaseline, Button, Avatar, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Countdown from 'react-countdown';
import { db } from '../../firebase';
import BarLogin from '../Screen/BarLogin';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  root: {
   
    justifyContent: 'center',
    alignItems: 'center'
  },
  avatar: {
    margin: '1rem',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: '1rem',
  },
  submit: {
    margin: '3rem',
    padding: '1.5',
  },
  checkboxLabel: {
      fontSize: 12
  }
}));

function TwoFa() {
  const classes = useStyles();
  const [password, setPassword] = React.useState('');
  const history = useNavigate()
  const [show, setShow] = React.useState(false);
  const [valid, setValid] = React.useState('');
  let {id} = useParams()

   const handleSubmit = (e) => {
    e.preventDefault();
    db.collection('users').doc(id).get().then(function(snapshot){
         if(snapshot.data().code==password)
          {
            if(snapshot.data().type=='admin')
            {
              history('/'+id)
            }
            else{
history('/create/'+id)
            }
          }
          else
          {
            setValid('Incorrect Otp')
          }
      })  
  }

  const handleClickShowPassword = () => {
    setShow(!show);
  };

  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };
   const resendCode=(e)=>{
    
  }
  return (
    <div className={classes.root}>
    <BarLogin/>
        <Container component="main" maxWidth="xs" className="card" style={{padding:'3rem'}}>
            <CssBaseline />
            <Paper className={classes.paper} style={{padding:'2rem'}}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                {valid ? (
                    <Alert onClose={() => {setValid('')}} severity="error">
                       {valid}
                    </Alert>
                ) : null}
                <Typography component="h5" variant="h6">
                Two Factor Authentication
                </Typography>
                <p  style={{textAlign:"center"}}>Please enter the code you were sent</p>
                <form className={classes.form} noValidate>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="code"
                        label="code"
                        type={show ? 'text' : 'password'}
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        InputProps={{
                          endAdornment: (
                              <InputAdornment position="end">
                                  <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={handleClickShowPassword}
                                      onMouseDown={handleMouseDownPassword}
                                  >
                                      {show ? <Visibility /> : <VisibilityOff />}
                                  </IconButton>
                              </InputAdornment>
                          )
                      }}
                    />  
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        size="large"
                        className={classes.submit}
                        /*component={Link}
                        to="/dashboard"*/
                        onClick={handleSubmit}
                    >
                        Verify Token
                    </Button>
                    
                    <Countdown date={Date.now() + 100000}>
      <b style={{color:'#D4AF37', cursor:'pointer'}} onClick={resendCode}>Resend Code</b>
    </Countdown>
                </form>
            </Paper>
        </Container>
      </div>
  )
}

export default TwoFa